import { useEffect, useState } from 'react';

import Link, { LinkTheme } from 'components/link/Link';

import { IChapterLink } from 'source/NFR.types';

interface IChapterLinkProps extends IChapterLink {
  isHeader?: boolean;
  isTopLevelLink?: boolean;
}

const ChapterLink: React.FC<IChapterLinkProps> = ({ chapterNumber, hasDash, link, isHeader, isTopLevelLink }) => {
  const [linksToCurrentPage, setLinksToCurrentPage] = useState<boolean>(false);

  useEffect(() => {
    const currPath = window.location.pathname;
    const currLink = link.url;
    if (currPath === currLink) {
      setLinksToCurrentPage(true);
    }
  }, [link.url]);

  const themes: LinkTheme[] = [];
  if (isHeader || isTopLevelLink) {
    themes.push('bold');
  }
  if (linksToCurrentPage) {
    themes.push('underline');
  }
  if (isTopLevelLink && chapterNumber) {
    themes.push('extraIndentation');
  }

  return (
    <Link className="chapter-link" theme={themes} {...link}>
      {chapterNumber && <span className="chapter-link--number">{chapterNumber}</span>}

      {hasDash && <span className="chapter-link--dash" />}
    </Link>
  );
};

ChapterLink.displayName = 'ChapterLink';

export default ChapterLink;
